"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.notAny = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

exports.noOp = noOp;
exports.assert = assert;
exports.toString = toString;
exports.isString = isString;
exports.isNumber = isNumber;
exports.isNull = isNull;
exports.isTrue = isTrue;
exports.isFalse = isFalse;
exports.not = not;
exports.or = or;
exports.isA = isA;
exports.selectKeys = selectKeys;
exports.mapIndexed = mapIndexed;
exports.second = second;
exports.ffirst = ffirst;
exports.minus = minus;
exports.nodelistToClj = nodelistToClj;
exports.indexOf = indexOf;
exports.isArray = isArray;
exports.memoize = memoize;
exports.combineStrings = combineStrings;
exports.endsWith = endsWith;
exports.mapv = mapv;
exports.mergeWith = mergeWith;
exports.deepMerge = deepMerge;

var _mori = require("mori");

var _atom = require("atom");

// We should consider creating a fork of Mori.js, which exports
// the functions in this namespace that were ported from Clojure from
// ClojureScript directly. -fmw

function noOp() {
  return null;
}

// https://clojuredocs.org/clojure.core/assert
function assert(expr, message) {
  if (expr) {
    return expr;
  } else {
    throw new Error(message);
  }
}

function toString(obj) {
  return obj && obj.toString ? obj.toString() : obj;
}

// https://clojuredocs.org/clojure.core/string_q
function isString(x) {
  return typeof x === "string";
}

// https://clojuredocs.org/clojure.core/number_q
function isNumber(x) {
  return typeof x === "number";
}

// https://clojuredocs.org/clojure.core/nil_q
function isNull(x) {
  return x === null;
}

// https://clojuredocs.org/clojure.core/true_q
function isTrue(x) {
  return x === true;
}

// https://clojuredocs.org/clojure.core/false_q
function isFalse(x) {
  return x === false;
}

// https://clojuredocs.org/clojure.core/not
function not(x) {
  return !x;
}

// https://clojuredocs.org/clojure.core/or
function or(x, y) {
  return x || y;
}

function isA(x, Type) {
  return x instanceof Type;
}

// https://clojuredocs.org/clojure.core/select-keys
function selectKeys(m, keySeq) {
  function f(ret, keys) {
    if (!(0, _mori.isEmpty)(keys)) {
      var entry = (0, _mori.find)(m, (0, _mori.first)(keys));

      if (entry) {
        return f((0, _mori.assoc)(ret, (0, _mori.nth)(entry, 0), (0, _mori.nth)(entry, 1)), (0, _mori.rest)(keys));
      } else {
        return f(ret, (0, _mori.rest)(keys));
      }
    } else {
      return ret;
    }
  }

  return f((0, _mori.hashMap)(), keySeq);
}

// deprecated, in mori.js now.
function mapIndexed(fn, coll) {
  return (0, _mori.map)(fn, coll, (0, _mori.range)());
}

var notAny = exports.notAny = (0, _mori.comp)(not, _mori.some);

// https://clojuredocs.org/clojure.core/second
function second(coll) {
  return (0, _mori.first)((0, _mori.rest)(coll));
}

// https://clojuredocs.org/clojure.core/ffirst
function ffirst(coll) {
  return (0, _mori.first)((0, _mori.first)(coll));
}

// https://clojuredocs.org/clojure.core/-
function minus(x, y) {
  return x - y;
}

function nodelistToClj(nodelist) {
  return (0, _mori.toClj)(Array.prototype.slice.call(nodelist));
}

function indexOf(v, item) {
  return (0, _mori.some)(function (x) {
    if ((0, _mori.equals)((0, _mori.first)(x), item)) {
      return (0, _mori.last)(x);
    } else {
      return false;
    }
  }, (0, _mori.partition)(2, (0, _mori.interleave)(v, (0, _mori.range)())));
}

function isArray(item) {
  return Object.prototype.toString.call(item) === "[object Array]";
}

// https://clojuredocs.org/clojure.core/memoize
function memoize(f) {
  var mem = (0, _atom.atom)((0, _mori.hashMap)());

  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var argsVector = (0, _mori.into)((0, _mori.vector)(), args);
    var e = (0, _mori.get)((0, _atom.deref)(mem), argsVector);

    if (e) {
      return e;
    } else {
      var ret = (0, _mori.apply)(f, argsVector);

      (0, _atom.swap)(mem, (0, _mori.curry)(_mori.assoc, argsVector, ret));

      return ret;
    }
  };
}

function combineStrings(sep, coll) {
  return (0, _mori.reduce)(function (accumulator, s) {
    return accumulator.concat(s);
  }, "", (0, _mori.interpose)(sep, coll));
}

function endsWith(s, needle) {
  if (typeof s === "string") {
    return s.lastIndexOf(needle) + needle.length === s.length;
  }
}

// https://clojuredocs.org/clojure.core/mapv
function mapv() {
  for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  return (0, _mori.into)((0, _mori.vector)(), (0, _mori.apply)(_mori.map, args));
}

// https://clojuredocs.org/clojure.core/merge-with
function mergeWith(f) {
  for (var _len3 = arguments.length, maps = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    maps[_key3 - 1] = arguments[_key3];
  }

  if ((0, _mori.some)(_mori.identity, maps)) {
    var _ret = function () {
      var mergeEntry = function mergeEntry(m, kv) {
        var k = (0, _mori.first)(kv);
        var v = second(kv);

        if ((0, _mori.hasKey)(m, k)) {
          return (0, _mori.assoc)(m, k, f((0, _mori.get)(m, k), v));
        } else {
          return (0, _mori.assoc)(m, k, v);
        }
      };

      var merge2 = function merge2(m1, m2) {
        return (0, _mori.reduce)(mergeEntry, m1 || (0, _mori.hashMap)(), (0, _mori.seq)(m2));
      };

      return {
        v: (0, _mori.reduce)(merge2, maps)
      };
    }();

    if ((typeof _ret === "undefined" ? "undefined" : _typeof(_ret)) === "object") return _ret.v;
  }
}

function deepMerge() {
  for (var _len4 = arguments.length, vals = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    vals[_key4] = arguments[_key4];
  }

  return (0, _mori.every)(_mori.isMap, vals) ? mergeWith.apply(undefined, [deepMerge].concat(vals)) : (0, _mori.last)(vals);
}